import { KebabCase } from 'type-fest';

export type IBettingSpacing = {
    topOffset: number;
    bottomOffset: number;
};

export const DEFAULT_SPACING: IBettingSpacing = {
    topOffset: 50,
    bottomOffset: 50,
};

export type SpacingCssProp = `--${KebabCase<keyof IBettingSpacing>}`;

export type SpacingCssVariables = {
    [key in IBettingSpacing as SpacingCssProp]: `${number}px`;
};
